<div class="loading-container">
  <img [src]="currentGif"  alt="Loading...">
  <p>{{ currentPhrase }}</p>
</div>
